import { render, staticRenderFns } from "./InteractEdit.vue?vue&type=template&id=628bf537&"
import script from "./InteractEdit.vue?vue&type=script&lang=js&"
export * from "./InteractEdit.vue?vue&type=script&lang=js&"
import style0 from "./InteractEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports